import React, { Component } from "react";
import Toggle from "./toggle";

class CardsToggleComponent extends Component {
  constructor(props) {
    super(props);
  }

  componentDidCatch(error) {
    /* eslint-disable-next-line */
    console.log(error);
  }

  render() {
    return (
      <div>
        <Toggle api={this.props} />
      </div>
    );
  }
}

export default CardsToggleComponent;
